module.exports = __webpack_public_path__ + "static/le-buns-00-hero-cf3cb2ad58278726f5bc7ffd95b0a9f5.jpg";